import { RiCloseFill } from "react-icons/ri"
import { AbsoluteContainer, AppLabel, AppSpan, AppText, CustomContainer, FlexRow, GridContainer, SidePopup, SidePopupContainer } from "src/style"


export const Notification: React.FC<any> = ({close}) => {

    
    return (
        <>
            <SidePopupContainer onClick={close} />
            <SidePopup padding="2" data-aos="slide-left">
                <FlexRow justifyContent="space-between" rightPadding="4" topMargin="1.5" bottomMargin="2">
                    <AppLabel color="#101225" fontWeight="600">Notifications</AppLabel>
                    <AppSpan color="#4C6FFF" textSize="1.2">Mark as read</AppSpan>
                    <AbsoluteContainer top="0" right="0" onClick={close}>
                        <RiCloseFill className='close-icon' />
                    </AbsoluteContainer>
                </FlexRow>

                <CustomContainer>
                    { 
                        Array.from(Array(6).keys()).map((item: any, index: number) => {
                            return (
                                <FlexRow 
                                    justifyContent="space-between" topPadding="2" bottomPadding="1.5"
                                    key={index} className='notification-item'
                                >
                                    <FlexRow alignItems="flex-start" width="35.2" rightMargin="1.5">
                                        <GridContainer 
                                            height="4" width="5" radius="0.3" 
                                            bgColor="#4C6FFF" rightMargin="1.5"
                                        >
                                            <AppText textSize="1.7" fontWeight="700" color="#ffffff">M</AppText>
                                        </GridContainer>
                                        <CustomContainer>
                                            <AppText textSize="1" fontWeight="500" color="#718096">Assigned to you</AppText>
                                            <AppSpan textSize="1.2">James Johnsnon assigned the ticket (#3) Received a broken TV to you</AppSpan>
                                        </CustomContainer>
                                    </FlexRow>
                                    <AppSpan textSize="1" fontWeight="500" color="#718096">10 mins ago</AppSpan>
                                </FlexRow>
                            )
                        })
                    }
                </CustomContainer>
            </SidePopup>
        </>
    )
}